import React from 'react'
import ContentLoader from 'react-content-loader'

const Loader = () => {


  return (
    <ContentLoader
      speed={2}
      width={1120}
      height={160}
      viewBox={`0 0 1120 ${160}`}
      backgroundColor='#f3f3f3'
      foregroundColor='#ecebeb'
    >


      <>
        <rect x='40' y={0} rx='3' ry='3' width='190' height='150'/>

        <rect x='270' y={0 } rx='3' ry='3' width='100' height='12'/>
        <rect x='270' y={40} rx='3' ry='3' width='150' height='12'/>

        <rect x='450' y={0 } rx='3' ry='3' width='70' height='12'/>
        <rect x='450' y={40} rx='3' ry='3' width='120' height='12'/>

        <rect x='600' y={0 } rx='3' ry='3' width='100' height='12'/>
        <rect x='600' y={40} rx='3' ry='3' width='120' height='12'/>

        <rect x='750' y={0 } rx='3' ry='3' width='100' height='12'/>
        <rect x='750' y={40} rx='3' ry='3' width='200' height='12'/>

      </>


    </ContentLoader>
  )
}

export default Loader